import React, { useEffect, useState, useContext } from 'react';
import { useParams, useHistory  } from 'react-router-dom';
import Input from '../../shared/components/formElements/Input';
import { AuthContext } from '../../shared/context/auth-context';

import Button from '../../shared/components/formElements/Button';
import Card from '../../shared/components/UIElements/Card';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_MINLENGTH,
  VALIDATOR_MAXLENGTH,
  VALIDATOR_SPECIAL_CHARACHTER,
} from '../../shared/util/validators';
import { useForm } from '../../shared/hooks/form-hook';
import { useHttpClient } from '../../shared/hooks/http-hook';
import './Customers.css';

const UpdateCustomer = () => {
  const auth = useContext(AuthContext);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const customerID = useParams().customerId;
  const [identifiedCustomer, setIdentifiedCustomer] = useState();
  const history = useHistory();

  const [formState, inputHandler, setFormData] = useForm(
    {
        name: {
            value: '',
            isValid: false
        },
        lastname: {
            value: '',
            isValid: false
        },
        phone: {
            value: '',
            isValid: false
        },
        address: {
            value: '',
            isValid: true,
        }
    },
    false
  );

  useEffect(()=> {
    const fetchCustomer = async () => {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL+`/customers/${customerID}`,
          "GET",
          null,
          {Authorization: 'Bearer '+ auth.token}
        );
        setIdentifiedCustomer(responseData.customer);
        setFormData(
          {
            name: {
              value: responseData.customer.name,
              isValid: true
            },
            lastname: {
              value: responseData.customer.lastname,
              isValid: true
            },
            phone: {
              value: responseData.customer.phone,
              isValid: true
            },
            address: {
              value: responseData.customer.address,
              isValid: true
            }
          },
          true
        );
      } catch (err) {}
    };
    fetchCustomer();

  }, [sendRequest, customerID, setFormData, auth.token]);

  const placeUpdateSubmitHandler = async event => {
    event.preventDefault();
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+`/customers/${customerID}/edit`,
        'PATCH',
        JSON.stringify({
          name: formState.inputs.name.value,
          lastname: formState.inputs.lastname.value,
          phone: formState.inputs.phone.value,
          address: formState.inputs.address.value
        }),
        {
          'Content-Type': 'application/json',
          Authorization: 'Bearer '+ auth.token
        }
      );
      history.push(`/customers/${customerID}`);
    } catch (err) {}

  };
  if (isLoading) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!identifiedCustomer && !error) {
    return (
      <div className="center">
        <Card>
          <h2>Could not find the customer!</h2>
        </Card>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {!isLoading && identifiedCustomer && (
      <div className="new-customer-list">
        <Card className="customer-item__content" >
        <h2 className="header-text">Edit Customer</h2>
          <form className="place-form" onSubmit={placeUpdateSubmitHandler}>
              <Input
                  id="name"
                  element="input"
                  type="text"
                  label="Name"
                  validators={[VALIDATOR_REQUIRE() ,VALIDATOR_SPECIAL_CHARACHTER()]}
                  errorText="Please enter a name."
                  onInput={inputHandler}
                  initialValue={formState.inputs.name.value}
                  initialValid={formState.inputs.name.isValid}
              />
              <Input
                  id="lastname"
                  element="input"
                  type="text"
                  label="LastName"
                  validators={[VALIDATOR_REQUIRE(), VALIDATOR_SPECIAL_CHARACHTER()]}
                  errorText="Please enter a last name."
                  onInput={inputHandler}
                  initialValue={formState.inputs.lastname.value}
                  initialValid={formState.inputs.lastname.isValid}
              />
              <Input
                  id="phone"
                  element="input"
                  type="number"
                  label="Phone"
                  validators={[VALIDATOR_MINLENGTH(10), VALIDATOR_MAXLENGTH(10)]}
                  errorText="Please enter a valid phone number (XXXYYYZZZZ)."
                  onInput={inputHandler}
                  initialValue={formState.inputs.phone.value}
                  initialValid={formState.inputs.phone.isValid}
              />
              <Input
                  id="address"
                  element="input"
                  type="text"
                  label="Address"
                  validators={[VALIDATOR_REQUIRE(), VALIDATOR_MAXLENGTH(30) ,VALIDATOR_SPECIAL_CHARACHTER()]}
                  errorText="Please enter a valid address (Max 30 Characters)."
                  onInput={inputHandler}
                  initialValue={formState.inputs.address.value}
                  initialValid={formState.inputs.address.isValid}
              />
              <Button type="submit" disabled={!formState.isValid}>
                  UPDATE CUSTOMER
              </Button>
              <Button inverse to={`/customers/${customerID}`}>
                  CANCEL
              </Button>
          </form>
        </Card>
      </div>
      )}
    </React.Fragment>
  );
};

export default UpdateCustomer;
